import s from '@/components/event/share/ShareEvent.module.scss';

export const InviteEventBenefit = () => {
  return (
    <div className={`flex w-full flex-col items-center bg-[#1E176D] px-6 py-16 text-white md:py-20 ${s.benefit}`}>
      <div className={'text-[32px] font-bold leading-[1.3] md:text-[40px] lg:text-[48px]'}>이벤트 혜택</div>
      <div className={'mt-12 grid w-full grid-cols-1 justify-items-center gap-6'}>
        <BenefitCard
          overText={'누적 참여 3만명 이상'}
          title={'처음 초대 성공하면 10,000P'}
          contents={'초대 링크를 통해 친구가 환급금 조회를 완료하면\n네이버페이 1만 포인트 지급해드려요.'}
          notice={['처음 초대 성공한 친구 1명에 한해 지급돼요.', '초대받은 링크를 통해 환급금 조회를 완료해야 인정돼요.']}
          imagePath={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/event/share/gift-card-0.png`}
        />
        <BenefitCard
          overText={'횟수 제한 없이 무제한 초대 가능'}
          title={'초대할 때마다 5,000P'}
          contents={'초대한 친구가 조회하면 5,000원씩 적립,\n더 많은 친구에게 환급금 조회를 소개해보세요.'}
          accentContents={'100% 지급'}
          notice={['환급금 조회가 완료된 경우만 포인트가 지급돼요.', '초대받은 링크를 통해 환급금 조회를 완료해야 인정돼요.']}
          imagePath={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/event/share/gift-card-1.png`}
        />
        <BenefitCard
          overText={'초대받은 친구는'}
          title={'환급금 신청하면 수수료 할인!'}
          contents={'초대받은 친구를 위한 더 특별한 혜택!\n환급 신청하면 결제 수수료의 10%를 할인해드려요.'}
          notice={['수수료 할인은 결제 시에 자동으로 적용돼요.', '초대받은 링크로 환급금 신청 시에만 할인 적용돼요.']}
          imagePath={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/event/share/gift-card-2.png`}
        />
      </div>
    </div>
  );
};

const BenefitCard = ({ overText, title, contents, accentContents, notice, imagePath }: BenefitCardProps) => {
  return (
    <div className={'rounded-5 flex w-full max-w-[520px] flex-col items-center bg-white pb-10 pt-12 text-center leading-[1.4] text-gray-950'}>
      {overText && <div className={'text-18 md:text-22 font-semibold'}>{overText}</div>}
      <div className={'text-20 md:text-26 mb-8 font-bold'}>{title}</div>
      <img className={s.gift_card_image} src={imagePath} alt={'gift card'} />
      <div className={'text-13 md:text-15 whitespace-pre font-medium leading-[1.45]'}>{contents}</div>
      {accentContents && <div className={'text-18 md:text-22 whitespace-pre font-bold leading-[1.45]'}>{accentContents}</div>}
      <div className={'text-12 mt-2 leading-[1.45] text-gray-800'}>
        {notice.map((message, index) => (
          <div key={index}>*{message}</div>
        ))}
      </div>
    </div>
  );
};

type BenefitCardProps = {
  overText?: string;
  title: string;
  contents: string;
  accentContents?: string;
  notice: string[];
  imagePath: string;
};
